import { Component,ViewChild,Input } from '@angular/core';
import { Router } from "@angular/router";
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
  selector: 'app-web-order-type-steps-page',
  templateUrl: 'web-order-type-steps.page.html',
  styleUrls: [
    './web-order-type-steps.page.scss',
  ]
})
export class WebOrderTypeStepsPage {

  @Input() typeCode: string;
   constructor(
        private systemSettingService: SystemSettingService,
            private toasterService: ToasterService,
            private router:Router
      ) { 
  
    }
  loading:boolean=true ;
  woOrderSteps:any;



  ngOnInit() {
    this.loadData(); 
  }

  async loadData() {
    this.loading=false;
    await this.systemSettingService.getWebOrderSteps(this.typeCode).then((response) => {
        this.woOrderSteps = response;

      });
      
        this.loading=true;

    }
  async saveWebOrderTypeSteps() {
  
      await this.systemSettingService.updateWebOrderSteps(this.woOrderSteps).then((response) => {
        if (response =='success') {
          this.toasterService.presentToast(
            "primary",
            " The Item was Updated Successfully! ",
            "Success"
          );
             this.loading=true;
        } else {
          this.toasterService.presentToast(
            "danger",
            `Error Updating Web Customer Setting.`,
            "Error"
          );  
             this.loading=true;
                }
    });
      this.loading=true;
      }
 
}